import moment from 'moment';
require('moment/locale/ja');
moment.locale('ja');

export default moment;
